
<!--stream$ | async as stream; else loading-->

<div class="streams-page"  *ngIf="stream; else loading" > 
   
   
    
    <div class="video-wrapper"  *ngIf="source; else loading"> 
        
        <div  *ngIf="!hasCounter"  [ngClass]="{videoCentering: !isEmbed}">
          
  <watch-video-player #video [socket]="socket" [stream]="stream" *ngIf="source" [sources]="[ { src: source,
                type: 'application/x-mpegURL' }]" [coverImage]="stream.coverImage || ''"></watch-video-player>
      
             
        </div>

		<app-watch-countdown *ngIf="hasCounter" [stream]="stream" [countData]="stream.counter" [cover]="stream.coverImage || ''" (onDone)="counterOnDone()"></app-watch-countdown>
    </div> 

    

 


</div> 
  
<ng-template #loading>
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;">  <app-loader></app-loader> </div>
        </div>
</ng-template> 
